/* eslint-disable no-console */
import { onError } from '@apollo/client/link/error';
import { OperationDefinitionNode } from 'graphql';

import { EnvUtils } from '@/utils/env.utils';
import { appInsights } from '@/services/Telemetry/AppInsights.service';
import { ExceptionTypes } from '@/config/LogEventTypes.config';

export const errorLink = onError(({ forward, operation, graphQLErrors, networkError }) => {
  if (!graphQLErrors?.length) {
    return forward(operation);
  }

  graphQLErrors.forEach(({ message, extensions }) => {
    const operationType = (operation.query.definitions[0] as OperationDefinitionNode)?.operation;
    const context = operation.getContext();

    if (EnvUtils.isProduction()) {
      appInsights.trackException({ error: new Error(message) }, {
        exceptionType: ExceptionTypes.GRAPHQL_EXCEPTION,
        pageUrl: window.location.href,
        subscriptionid: context?.headers?.subscriptionid ?? null,
        organisationid: context?.headers?.organisationid ?? null,
        appOperationName: operation.operationName,
        schemaOperationType: operationType ?? 'unknown operation',
        variables: operation.variables,
        apiErrorCode: extensions?.codes ?? 'unknown code'
      });
    }
  });

  if (networkError) {
    console.log(`[Network error]: ${networkError.message}`);
  }

  return undefined;
});
